import {
    type CreateBoardMemberResponseType,
    type CreateBoardMemberRequestType
} from "./type";
import {
    request
} from "../request";

const createBoardMember = async (params: CreateBoardMemberRequestType): Promise<CreateBoardMemberResponseType> => {
    return await request<CreateBoardMemberResponseType>("/content/createBoardMember", {
        body: JSON.stringify(params),
        method: "POST"
    });
};
export default createBoardMember;
